import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
  noIndex?: boolean;
}

export default function SEOHead({
  title = '韩国漫画无删减漫画下拉式-免费韩漫在线阅读-桃桃漫画网',
  description = '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。',
  keywords = '韩国漫画,无删减漫画,下拉式漫画,免费韩漫,在线阅读,桃桃漫画网',
  canonicalUrl = 'https://www.taotao-comic.com',
  ogType = 'website',
  ogImage,
  schema,
  noIndex = false,
}: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://www.taotao-comic.com';
  const fullCanonical = canonicalUrl.startsWith('http') ? canonicalUrl : `${baseUrl}${canonicalUrl}`;

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = 'zh-CN';

    const setMeta = (name: string, content: string, attrName = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('robots', noIndex ? 'noindex, nofollow' : 'index, follow');

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', ogType, 'property');
    setMeta('og:url', fullCanonical, 'property');
    setMeta('og:locale', 'zh_CN', 'property');
    if (ogImage) {
      setMeta('og:image', ogImage, 'property');
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (link) {
      link.setAttribute('href', fullCanonical);
    }

    if (schema) {
      const existingScript = document.querySelector('script[data-schema="dynamic"]');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'dynamic');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    return () => {
      const dynamicScript = document.querySelector('script[data-schema="dynamic"]');
      if (dynamicScript) dynamicScript.remove();
    };
  }, [title, description, keywords, fullCanonical, ogType, ogImage, schema, noIndex, location.pathname]);

  return null;
}